// extracted by mini-css-extract-plugin
export default {"image":"NotificationEntity_image__Hk5OV","redCircle":"NotificationEntity_redCircle__SFXoX"};